<app-workflow-base  
  [displayComptabilitySection]="true"
  [goBackToWorkflowList]="goBackToWorkflowList"
  [validStages]="validStages"
  [createWorkflow]="createWorkflow"
  [updateWorkflow]="updateWorkflow"
  [activateWorkflow]="activateWorkflow"
  [deactivateWorkflow]="deactivateWorkflow"  
  [operationalGroupFilter]="operationalGroupFilter"
  [comtabilityGroupFilter]="comtabilityGroupFilter"
  [stageValidationGroupFilter]="stageValidationGroupFilter"
>
</app-workflow-base>